export default __webpack_public_path__ + "9adc71b4f21ca200708dc12c9d876c99.png";